import { useState, useEffect } from "react";
import { BehaviorSubject } from "rxjs";

let subject = null;
let data = null;

export const getAllStore = () => {
    if (!subject) {
        return undefined;
    }

    return subject.value;
};

export const useSharedStore = () => {
    const [store, setStore] = useState({});

    if (!subject) {
        subject = new BehaviorSubject({});
    }

    useEffect(() => {
        data = null;
        const subscription = subject.subscribe((obj) => {
            data = obj;
            setStore(obj);
        });

        return () => {
            if (subscription) {
                subscription.unsubscribe();
            }
        };
    }, []);

    function addStore(key, value) {
        subject.next({ ...store, [key]: value });
    }

    function getStore(key) {
        return store[key]
    }

    function getStoreAsync(key) {
        return new Promise((resolve, reject) => {
            const myInterval = setInterval(function () {
                if (data != null) {
                    resolve(data[key]);
                    clearInterval(myInterval);
                }
            }, 500);
        });
    }

    function clear() {
        subject.next({});
    }

    return { addStore, clear, getStore, store, getStoreAsync };
};
